<template>
    <div class="settings">
        <v-tabs v-model="tab" class="mb-6">
            <v-tab v-for="item in tabs" :key="item" :text="item" :value="item" />
        </v-tabs>
        <v-tabs-window v-model="tab">
            <v-tabs-window-item :value="t('company_settings.api')">
                <company-settings-api-form :company-id="companyId" />
            </v-tabs-window-item>
            <v-tabs-window-item :value="t('company_settings.company_notifications')">
                <NotificationSettingsForm :company-id="companyId" :is-my-company-notifications="isMyCompanyPage" />
            </v-tabs-window-item>
            <v-tabs-window-item :value="t('company_settings.tourists_notifications')">
                <NotificationSettingsForm
                    :company-id="companyId"
                    :is-my-company-tourists-notifications="isMyCompanyPage"
                />
            </v-tabs-window-item>
            <v-tabs-window-item :value="t('notification_settings')">
                <NotificationSettingsForm :company-id="companyId" />
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script setup lang="ts">
    import CompanySettingsApiForm from '~/components/account/companies/settings/CompanySettingsApiForm.vue'
    import NotificationSettingsForm from '~/components/account/clients/NotificationSettingsForm.vue'

    const props = defineProps<{
        companyId: number
        isMyCompanyPage?: boolean
    }>()

    const {t} = useI18n()

    const tab = ref(null)
    const tabs = computed(() => {
        const tabList = [t('company_settings.api')]

        if (props.isMyCompanyPage) {
            tabList.push(t('company_settings.company_notifications'))
            tabList.push(t('company_settings.tourists_notifications'))
        } else {
            tabList.push(t('notification_settings'))
        }

        return tabList
    })
</script>
